import React from "react";
import { Alert, Form, Icon, Button, Select, Checkbox, Row, Col } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import {
  getUsersLight,
  getUserSites,
  copyBulkUserPermissions,
} from "../../api/requests";

import classes from "./CopyUserPermissionsForm.css";
import { logout } from "../../reducers/user/actions";
import uniq from "lodash/uniq";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class CopyUserPermissionsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      users: [],
      sites: [],
      sitesKeys: [],
      shiftDown: false,
    };
  }

  async componentDidMount() {
    const { data: users } = await getUsersLight();
    this.setState({ users });
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: true,
      });
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: false,
      });
    }
  };

  onTargetKeyChange = (index, key) => (e) => {
    const isChecked = e.target.checked;
    const { sitesKeys, sites, shiftDown } = this.state;
    if (sitesKeys.length && shiftDown) {
      const lastCheckedItemIndex = sites.findIndex(
        (item) => item.key === sitesKeys[sitesKeys.length - 1]
      );

      let newItems = [];

      if (lastCheckedItemIndex < index) {
        newItems = sites.reduce((result, item, itemIndex) => {
          return itemIndex > lastCheckedItemIndex && itemIndex <= index
            ? [...result, item.key]
            : result;
        }, []);
      } else {
        newItems = sites.reduce((result, item, itemIndex) => {
          return itemIndex < lastCheckedItemIndex && itemIndex >= index
            ? [...result, item.key]
            : result;
        }, []);
      }

      this.setState(({ sitesKeys }) => ({
        sitesKeys: uniq([...sitesKeys, ...newItems]),
      }));
    } else {
      this.setState(({ sitesKeys }) => ({
        sitesKeys: isChecked
          ? uniq([...sitesKeys, key])
          : uniq(sitesKeys.filter((item) => item !== key)),
      }));
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { sitesKeys } = this.state;

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        if (!sitesKeys.length) {
          this.setState({
            requestResult: {
              type: "warning",
              message: this.props.i18n.t(
                "NamespaceCopyUserPermissionsForm:Please, select role to copy"
              ),
            },
          });
          return;
        }

        this.setState({ isLoading: true });

        try {
          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          await copyBulkUserPermissions({
            from_user_id: values.from_user_id,
            to_user_id: values.to_user_id,
            from_site_ids: sitesKeys,
          });

          setTimeout(() => {
            this.props.onSubmit();
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });
        }
      }
    });
  };

  getUserSites = async (userId) => {
    this.setState({ sites: [] });
    const { data: sites } = await getUserSites(userId);
    this.setState({
      sites: sites.map((site) => ({
        key: site.id,
        name: site.name,
        code: site.code,
        chosen: false,
      })),
    });
  };

  render() {
    const { isLoading, requestResult, users, sites, sitesKeys } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceCopyUserPermissionsForm:Copy user permissions"
            )}
          </h4>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceCopyUserPermissionsForm:Source user"
                  )}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator("from_user_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t("Select User")}
                      onChange={this.getUserSites}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {users.map((user) => (
                        <Option
                          key={user.id}
                          value={user.id}
                          disabled={getFieldValue("to_user_id") === user.id}
                        >
                          {user.username}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col md={12}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceCopyUserPermissionsForm:Destination user"
                  )}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator("to_user_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t("Select User")}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {users.map((user) => (
                        <Option
                          key={user.id}
                          value={user.id}
                          disabled={getFieldValue("from_user_id") === user.id}
                        >
                          {user.username}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row>
            <Col>
              {sites.length > 0 && (
                <div style={{ paddingBottom: "12px" }}>
                  <label>
                    <Checkbox
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState(() => ({
                            sitesKeys: sites.map(({ key }) => key),
                          }));
                        } else {
                          this.setState(() => ({
                            sitesKeys: [],
                          }));
                        }
                      }}
                    />
                    <b>
                      &nbsp; {this.props.i18n.t("Check all")} &nbsp; (
                      {sitesKeys.length}/{sites.length})
                    </b>
                  </label>
                </div>
              )}

              {sites
                .sort((a, b) => get(a, "code") - get(b, "code"))
                .map(({ key, name, code }, i) => (
                  <div key={key} style={{ paddingBottom: "4px" }}>
                    <label>
                      <Checkbox
                        checked={
                          sitesKeys.findIndex(
                            (targetKey) => targetKey === key
                          ) > -1
                        }
                        onChange={this.onTargetKeyChange(i, key)}
                      />
                      &nbsp;
                      {code} - {name}
                    </label>
                  </div>
                ))}

              <br />
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
                disabled={isLoading}
              >
                {this.props.i18n.t("Submit")}
                {isLoading && <Icon type="loading" />}
              </Button>
              &nbsp; &nbsp;
              <Button
                type="default"
                size="large"
                htmlType="button"
                className={classes.submitButton}
                onClick={this.props.onCancel}
              >
                {this.props.i18n.t("Cancel")}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (_) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "drugShip" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(CopyUserPermissionsForm))
);



// WEBPACK FOOTER //
// ./src/components/CopyUserPermissionsForm/CopyUserPermissionsForm.js